import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=8c3d8448"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports